import React from 'react';
import { SearchDialog } from '@atlassian/search-dialog';
import { useDialogExpansionContext } from '../../dialog-expansion-context';
import { useFeaturesContext } from '../../features-context/features-context';
export var ProductSearchDialogWrapper = function ProductSearchDialogWrapper(_ref) {
  var children = _ref.children;
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  var _useFeaturesContext = useFeaturesContext(),
    quickFind = _useFeaturesContext.quickFind;
  return /*#__PURE__*/React.createElement(SearchDialog, {
    style: {
      boxShadow: isExpanded ? undefined : 'none',
      borderRadius: quickFind !== null && quickFind !== void 0 && quickFind.enabled ? "var(--ds-space-100, 8px)" : undefined
    }
  }, children);
};